import common from "./common.json";

export const br = {
  common,
};
